// Dashboard stats-summary payload schema (`GET /stats/summary`). `snapshots` is a
// required array; `lastSnapshot` is nullable — the mapper returns `lastSnapshot: null`
// when the snapshot table is empty (fresh DB), and `useStatsSummary` already guards
// that with `data.lastSnapshot ?? { data: {} }`. Count fields are nullish leaves;
// `looseObject` preserves any undeclared keys (see the note in `common.ts`).

import * as v from 'valibot';

const snapshotCountsSchema = v.looseObject({
  players: v.nullish(v.number()),
  players24h: v.nullish(v.number()),
  cards: v.nullish(v.number()),
  cards24h: v.nullish(v.number()),
  limited24h: v.nullish(v.number()),
  rare24h: v.nullish(v.number()),
  super24h: v.nullish(v.number()),
  unique24h: v.nullish(v.number()),
});

export const statsSummarySchema = v.looseObject({
  lastSnapshot: v.nullish(
    v.looseObject({
      data: snapshotCountsSchema,
      updated: v.nullish(v.string()),
    }),
  ),
  snapshots: v.array(
    v.looseObject({
      // Every snapshot row carries its `taken_at` timestamp (`dashboardStats` does
      // `new Date(updated)`); a row without it is a genuine contract violation.
      updated: v.string(),
      data: snapshotCountsSchema,
    }),
  ),
});
